import { render, staticRenderFns } from "./bottomList.vue?vue&type=template&id=2a34c5c0&scoped=true&"
import script from "./bottomList.vue?vue&type=script&lang=js&"
export * from "./bottomList.vue?vue&type=script&lang=js&"
import style0 from "./bottomList.vue?vue&type=style&index=0&id=2a34c5c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a34c5c0",
  null
  
)

export default component.exports